<div class="mb-4 flex bg-gray-100 rounded-2xl border p-4">
  <div class="flex flex-1">
    <p>estateSmart Konvertierung - Kundenauswahl</p>
  </div>
  <div class="flex flex-1 justify-end">
    <img class="h-5 w-auto" src="../assets/icons/estateSmart-logo.png" alt="" />
  </div>
</div>
